import React from 'react';
import { ProductsData } from '../../data/product/productsData';
import './styles.scss';
import ProductList from './global_components/ProductsList';
import TopBar from './global_components/TopBar';
import LayoutPage from '../../layouts/Main';

export default function Catalog({ catalog: node, parentCategory }) {
  const productsData = ProductsData;

  return (
    <LayoutPage>
      {/* Revision si afecta en algo!!!!!<TopBar isCategory={false} categorie={parentCategory}/> */} 
      <ProductList products={productsData} catalog={node.name} category={parentCategory}/>
    </LayoutPage>
  );
}